__turbopack_context__.v({
  "activeTab": "InterviewPrep-module__1NlSJW__activeTab",
  "askQuestion": "InterviewPrep-module__1NlSJW__askQuestion",
  "askWhy": "InterviewPrep-module__1NlSJW__askWhy",
  "categoryBadge": "InterviewPrep-module__1NlSJW__categoryBadge",
  "container": "InterviewPrep-module__1NlSJW__container",
  "content": "InterviewPrep-module__1NlSJW__content",
  "copyButton": "InterviewPrep-module__1NlSJW__copyButton",
  "copyQuestionButton": "InterviewPrep-module__1NlSJW__copyQuestionButton",
  "copyStarButton": "InterviewPrep-module__1NlSJW__copyStarButton",
  "dayBeforeList": "InterviewPrep-module__1NlSJW__dayBeforeList",
  "difficultyBadge": "InterviewPrep-module__1NlSJW__difficultyBadge",
  "examplesHeader": "InterviewPrep-module__1NlSJW__examplesHeader",
  "expandIcon": "InterviewPrep-module__1NlSJW__expandIcon",
  "expanded": "InterviewPrep-module__1NlSJW__expanded",
  "formatList": "InterviewPrep-module__1NlSJW__formatList",
  "header": "InterviewPrep-module__1NlSJW__header",
  "mistakesList": "InterviewPrep-module__1NlSJW__mistakesList",
  "questionCard": "InterviewPrep-module__1NlSJW__questionCard",
  "questionCategories": "InterviewPrep-module__1NlSJW__questionCategories",
  "questionCategory": "InterviewPrep-module__1NlSJW__questionCategory",
  "questionDetails": "InterviewPrep-module__1NlSJW__questionDetails",
  "questionHeader": "InterviewPrep-module__1NlSJW__questionHeader",
  "questionMeta": "InterviewPrep-module__1NlSJW__questionMeta",
  "questionText": "InterviewPrep-module__1NlSJW__questionText",
  "questionToAsk": "InterviewPrep-module__1NlSJW__questionToAsk",
  "questionsList": "InterviewPrep-module__1NlSJW__questionsList",
  "redFlagIcon": "InterviewPrep-module__1NlSJW__redFlagIcon",
  "redFlagItem": "InterviewPrep-module__1NlSJW__redFlagItem",
  "redFlagsList": "InterviewPrep-module__1NlSJW__redFlagsList",
  "redFlagsSection": "InterviewPrep-module__1NlSJW__redFlagsSection",
  "sampleAnswer": "InterviewPrep-module__1NlSJW__sampleAnswer",
  "sampleAnswerHeader": "InterviewPrep-module__1NlSJW__sampleAnswerHeader",
  "starBreakdown": "InterviewPrep-module__1NlSJW__starBreakdown",
  "starExample": "InterviewPrep-module__1NlSJW__starExample",
  "starExamples": "InterviewPrep-module__1NlSJW__starExamples",
  "starIntro": "InterviewPrep-module__1NlSJW__starIntro",
  "starLabel": "InterviewPrep-module__1NlSJW__starLabel",
  "starLetter": "InterviewPrep-module__1NlSJW__starLetter",
  "starRow": "InterviewPrep-module__1NlSJW__starRow",
  "starStep": "InterviewPrep-module__1NlSJW__starStep",
  "subtitle": "InterviewPrep-module__1NlSJW__subtitle",
  "tab": "InterviewPrep-module__1NlSJW__tab",
  "tabIcon": "InterviewPrep-module__1NlSJW__tabIcon",
  "tabIntro": "InterviewPrep-module__1NlSJW__tabIntro",
  "tabLabel": "InterviewPrep-module__1NlSJW__tabLabel",
  "tabNav": "InterviewPrep-module__1NlSJW__tabNav",
  "tipIcon": "InterviewPrep-module__1NlSJW__tipIcon",
  "tipItem": "InterviewPrep-module__1NlSJW__tipItem",
  "tipSection": "InterviewPrep-module__1NlSJW__tipSection",
  "tipSectionIcon": "InterviewPrep-module__1NlSJW__tipSectionIcon",
  "tipsList": "InterviewPrep-module__1NlSJW__tipsList",
  "tipsSection": "InterviewPrep-module__1NlSJW__tipsSection",
  "tipsTab": "InterviewPrep-module__1NlSJW__tipsTab",
  "title": "InterviewPrep-module__1NlSJW__title",
  "xIcon": "InterviewPrep-module__1NlSJW__xIcon",
});
